import React, { PureComponent } from 'react';
import autobind from 'autobind-decorator';
import styled from 'styled-components';
import Icon, { Container } from './Icon';

const RADIO = 'RADIO';
const CHECKBOX = 'CHECKBOX';
const DISABLED_OPACITY = 0.5;

const StyledInput = styled.input`
  opacity: 0;
  position: absolute;

  &:focus + ${Container} {
    ${({ theme }) => theme.mixins.focusBorder};
  }
`;

export default class ChoiceInput extends PureComponent {
  static Types = {
    RADIO,
    CHECKBOX,
  };

  @autobind
  onChange() {
    const { onChange, disabled, selected } = this.props;

    if (disabled) return;

    onChange && onChange(!selected);
  }

  getIconProps() {
    const { selected, type } = this.props;

    let props = {
      iconSize: 12,
      icon: 'circle',
      containerType: 'circle',
      borderColor: 'checkboxBorder',
      containerColor: 'silver',
      color: selected ? 'defaultActionBlue' : 'transparent',
    };

    if (type === ChoiceInput.Types.CHECKBOX) {
      props = {
        ...props,
        iconSize: 10,
        icon: 'check',
        containerType: 'square',
        borderColor: selected ? 'defaultActionBlue' : 'checkboxBorder',
        containerColor: selected ? 'defaultActionBlue' : 'silver',
        cornerRadius: 2,
        color: selected ? 'white' : 'transparent',
      };
    }

    return props;
  }

  render() {
    const { selected, type, disabled, inputRef } = this.props;

    return (
      <span onClick={this.onChange}>
        <StyledInput
          type={type ? 'checkbox' : 'radio'}
          checked={selected || false}
          onChange={this.onChange}
          disabled={disabled}
          ref={inputRef}
        />
        <Icon
          size={18}
          opacity={disabled ? DISABLED_OPACITY : 1}
          {...this.getIconProps()}
        />
      </span>
    );
  }
}
